export const playerDocs = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "alias": "Proper Lemur",
    "currency": 550,
    "currencyTotal": 950,
    "displayName": "Julian S",
    "enroll_method": "upload",
    "fName": "Julian",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #efbbb5, #5696a5)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Sterling",
    "path": "o0bdk4vme7-ev7p6q3",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "points": 450,
    "status": "active",
    "team": false,
    "ts": 1774615665827
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "alias": "Inventive Mantis",
    "currency": 200,
    "currencyTotal": 200,
    "displayName": "Ivy S",
    "enroll_method": "upload",
    "fName": "Ivy",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #f99e72, #3b2bd3)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Sinclair",
    "path": "q5cqhyxw6mpw9rd3ni",
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1773161482683
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "alias": "Faithful Deer",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Marcus T",
    "enroll_method": "upload",
    "fName": "Marcus",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #065868, #3c6b24)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Thorne",
    "path": "s_04hnqzcm2yjumnb0",
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "alias": "Questioning Hawk",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Victor H",
    "enroll_method": "upload",
    "fName": "Victor",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #b8b43c, #9fb4c1)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Hugo",
    "path": "x3tvmbhymif00362ni",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774643897922
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "alias": "Cautious Curlew",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Silas V",
    "enroll_method": "upload",
    "fName": "Silas",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #70a495, #cd4f39)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Vane",
    "path": "bmvh6aoda7y9uojcw_",
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774615665899
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "alias": "Busy Jaguar",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Isabella R",
    "enroll_method": "upload",
    "fName": "Isabella",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #7d295a, #d61cff)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Romero",
    "path": "0d4po53js6vt59f8zj",
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "alias": "Popular Dolphin",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Penelope W",
    "enroll_method": "upload",
    "fName": "Penelope",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #22e58e, #ff6fa6)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Weaver",
    "path": "p_ui6ws5754qspj2fk",
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "alias": "Patient Crane",
    "currency": 200,
    "currencyTotal": 200,
    "displayName": "Jasper F",
    "enroll_method": "upload",
    "fName": "Jasper",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #12cf02, #ce2e13)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Finch",
    "path": "cudo2o__jhdh0_hm42",
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772981267710
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Named after the Senatus, the governing body of Rome. This title fits a team that excels at the rhetorical and analytical side of your literature curriculum the ones who love a good Socratic seminar.",
    "displayName": "The Gilded Senate",
    "enroll_method": "",
    "fName": "The Gilded Senate",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772687197598-Gemini_Generated_Image_mko59pmko59pmko5.jpg?alt=media&token=abb6c0e9-b303-4651-930f-3ffd96b834b0",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 8,
    "path": "7i9p9j_gwi7x0bwowq",
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1772687714019
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "alias": "Jealous Narwhal",
    "currency": 0,
    "currencyTotal": 200,
    "displayName": "Theodore C",
    "enroll_method": "upload",
    "fName": "Theodore",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #f10868, #1ab0cb)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Crane",
    "path": "yq78c6apfeqf97sw_-",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774623171459
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "alias": "Confident Giraffe",
    "currency": 1450,
    "currencyTotal": 1450,
    "displayName": "Elara F",
    "enroll_method": "upload",
    "fName": "Elara",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #99064e, #6e8490)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Frost",
    "path": "2uiwtc_w9wo88dhqj9",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "points": 600,
    "status": "active",
    "team": false,
    "ts": 1774501447697
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "alias": "Neat Mouse",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Leo M",
    "enroll_method": "upload",
    "fName": "Leo",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #d8be5d, #36ef15)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Maxwell",
    "path": "0cq39ufq8-sigmeb3y",
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774615664702
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "alias": "Reverent Newt",
    "currency": 50,
    "currencyTotal": 250,
    "displayName": "Beatrice K",
    "enroll_method": "upload",
    "fName": "Beatrice",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #04555b, #2c2c09)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Knight",
    "path": "arkjkd_em_5kc_7dsc",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774663211536
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "alias": "Mischievous Mouse",
    "currency": 500,
    "currencyTotal": 700,
    "displayName": "Sofia R",
    "enroll_method": "upload",
    "fName": "Sofia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #8dd86c, #79ba99)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Ricci",
    "path": "bid38pzjhsn52cckdr",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "points": 150,
    "status": "active",
    "team": false,
    "ts": 1774615665812
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "alias": "Reflective Mink",
    "currency": 400,
    "currencyTotal": 400,
    "displayName": "Xavier C",
    "enroll_method": "upload",
    "fName": "Xavier",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #03edc1, #684c5e)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Cross",
    "path": "m9pwe3ddnqf0wto0rn",
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774615665792
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "alias": "Honest Moose",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Clara W",
    "enroll_method": "upload",
    "fName": "Clara",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #d9e188, #d8a77f)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Whitlock",
    "path": "0w6gfikhjtsg8k5a6e",
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "alias": "Responsible Grouse",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Gideon H",
    "enroll_method": "upload",
    "fName": "Gideon",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #6bb507, #6d468e)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Holt",
    "path": "f25m7jpgqzguoa8gad",
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "alias": "Joyful Dragonfly",
    "currency": 100,
    "currencyTotal": 100,
    "displayName": "Felix A",
    "enroll_method": "upload",
    "fName": "Felix",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #7473dd, #5c264f)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Aris",
    "path": "nji5j50yzk6a-w66tw",
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774495499894
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "alias": "Popular Hornet",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Elena V",
    "enroll_method": "upload",
    "fName": "Elena",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #1141b2, #aa3286)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Vance",
    "path": "79yk7k4me-amx5v7oq",
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Inspired by the Legio, the backbone of the Roman army. This name is perfect for a group that is highly organized and tackles challenges with a \"never leave a man behind\" mentality.",
    "displayName": "The Iron Legion",
    "enroll_method": "",
    "fName": "The Iron Legion",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 9,
    "path": "kihibc_szszkza4zvo",
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1773006992238
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "alias": "Responsible Eel",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Lydia B",
    "enroll_method": "upload",
    "fName": "Lydia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #05dbbf, #1d69db)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Bennet",
    "path": "t4zaa6v4qxffjjxqjh",
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Drawing from the Sibylline Oracles and the protectors of sacred knowledge. This name is ideal for the group that digs deep into symbolism and always seems to find the \"hidden meaning\" in the texts you read.",
    "displayName": "The Oracle Guard",
    "enroll_method": "",
    "fName": "The Oracle Guard",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 9,
    "path": "w0c77_x8tyf27nm9ee",
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1773002414728
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "alias": "Pleasing Flamingo",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Maya H",
    "enroll_method": "upload",
    "fName": "Maya",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #f0c657, #d45525)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Huxley",
    "path": "pqmssxtk4ahxkbky96",
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "alias": "Confident Mosquito",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Hazel T",
    "enroll_method": "upload",
    "fName": "Hazel",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #c7c032, #93cd9c)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Thorne",
    "path": "s_zzkdwuk_iqor5b7d",
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "alias": "Questioning Moose",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Quentin M",
    "enroll_method": "upload",
    "fName": "Quentin",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #1d7b17, #a5d001)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Miller",
    "path": "0hwqwaja88v_yhj68f",
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "alias": "Honest Badger",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Adrian C",
    "enroll_method": "upload",
    "fName": "Adrian",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #c6864c, #d3e4c0)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Chen",
    "path": "ewciz9aohx7y0fd8dx",
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "alias": "Bold Mantis",
    "currency": 100,
    "currencyTotal": 100,
    "displayName": "Nadia S",
    "enroll_method": "upload",
    "fName": "Nadia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #312bcc, #21f35d)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Solis",
    "path": "7auhs3ex3h2hcqgnu-",
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774495500431
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "alias": "Strong Kookabura",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Rowan G",
    "enroll_method": "upload",
    "fName": "Rowan",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #e10a7e, #83caed)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Graves",
    "path": "xiss055dto09dgynf7",
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  }
}

export const leaderList = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "currency": 550,
    "currencyTotal": 950,
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "points": 450
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "currency": 200,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "points": 0
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "points": 0
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Victor H",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "points": 20
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "currency": 300,
    "currencyTotal": 300,
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "points": 0
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "points": 0
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "points": 0
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "currency": 200,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "points": 0
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "currency": 0,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "points": 0
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "currency": 1450,
    "currencyTotal": 1450,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "points": 600
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "currency": 300,
    "currencyTotal": 300,
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "points": 0
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "currency": 50,
    "currencyTotal": 250,
    "displayName": "Beatrice K",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "points": 0
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "currency": 500,
    "currencyTotal": 700,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "points": 150
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "currency": 400,
    "currencyTotal": 400,
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "points": 20
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "points": 0
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "points": 0
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "currency": 100,
    "currencyTotal": 100,
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "points": 20
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "points": 0
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "points": 0
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "points": 0
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "points": 0
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "points": 0
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "points": 0
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "currency": 100,
    "currencyTotal": 100,
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "points": 20
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "points": 0
  }
}

export const previewPasscodes = {
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": "1111",
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": "1111",
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": "1111",
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": "1111",
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": "1111",
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": "1111",
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": "1111",
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": "1111",
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": "1111",
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": "1111",
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": "1111",
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": "1111",
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": "1111",
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": "1111",
  "gameId": "1772165586781-LNymXRI-game",
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": "1111",
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": "1111",
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": "1111",
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": "1111",
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": "1111",
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": "1111",
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": "1111",
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": "1111",
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": "1111",
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": "1111",
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": "1111"
}

export const previewTeamMembers = {
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "path": "kihibc_szszkza4zvo",
    "members": [
      "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
      "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
      "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
      "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
      "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
      "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
      "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
      "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm"
    ],
    "teamId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "status": "active"
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "members": [
      "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
      "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
      "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
      "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
      "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
      "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
      "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
      "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr"
    ],
    "path": "w0c77_x8tyf27nm9ee",
    "status": "active",
    "teamId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team"
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "members": [
      "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
      "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
      "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
      "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
      "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
      "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
      "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
      "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9"
    ],
    "path": "7i9p9j_gwi7x0bwowq",
    "status": "active",
    "teamId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team"
  }
}

export const completePlayerData = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "alias": "Proper Lemur",
    "info": "HR - Thorne",
    "challenges": {
      "1772569770551-86781-LNymX-challenge": {
        "approved": true,
        "ts": 1774571686524,
        "count": 1,
        "tries": 2,
        "id": "1772569770551-86781-LNymX-challenge"
      },
      "1772569834612-86781-LNymX-challenge": {
        "tries": 2,
        "id": "1772569834612-86781-LNymX-challenge",
        "count": 1,
        "approved": true,
        "ts": 1774571645810
      }
    },
    "appId": "2Vo46bD7t6SWCo7PN9MPZME5",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "gradient": "linear-gradient(to bottom, #efbbb5, #5696a5)",
    "ts_lastLogin": 1774570819808,
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "ts": 1774615663451,
        "id": "1772590997526-86781-LNymX-prizepack",
        "count": 1
      }
    },
    "newStuff": [
      {
        "data": [
          {
            "type": "currency",
            "id": "currency",
            "quantity": 300
          },
          {
            "type": "prizepack",
            "id": "1772590997526-86781-LNymX-prizepack",
            "quantity": 1
          }
        ],
        "ts": 1774615663448,
        "display": "reward",
        "id": "1774615663448-2Vo46bD7t6SWCo7PN9MPZME5-rewards",
        "type": "rewards",
        "icon": "/images/icons/treasure.png"
      },
      {
        "type": "rewards",
        "id": "1774615663452-2Vo46bD7t6SWCo7PN9MPZME5-prizepack",
        "display": "prizepack",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "data": [
          {
            "id": "1772230537888-86781-LNymX-item",
            "type": "items",
            "quantity": 1
          },
          {
            "type": "items",
            "id": "1772230537891-86781-LNymX-item",
            "quantity": 1
          },
          {
            "type": "items",
            "id": "1772230537888-86781-LNymX-item",
            "quantity": 1
          }
        ],
        "ts": 1774615663452
      }
    ],
    "legalApproved": 1774570823400,
    "currency": 550,
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "ts": 1774570826804,
        "id": "1772590648474-86781-LNymX-level",
        "count": 1
      }
    },
    "points": 450,
    "ts_joined": 1772202099979,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Julian S",
    "status": "active",
    "fName": "Julian",
    "team": false,
    "lName": "Sterling",
    "currencyTotal": 950,
    "path": "o0bdk4vme7-ev7p6q3",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "icon": "",
    "items": {
      "1772230537891-86781-LNymX-item": {
        "id": "1772230537891-86781-LNymX-item",
        "ts": 1774615663454,
        "count": 1
      },
      "1772230537874-86781-LNymX-item": {
        "ts": 1774572899764,
        "total": 1,
        "count": 1,
        "id": "1772230537874-86781-LNymX-item",
        "totalSpent": 100
      },
      "1772230537882-86781-LNymX-item": {
        "totalSpent": 200,
        "id": "1772230537882-86781-LNymX-item",
        "count": 1,
        "total": 1,
        "ts": 1774572899764
      },
      "1772230537888-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537888-86781-LNymX-item",
        "ts": 1774615663453
      },
      "1772230537869-86781-LNymX-item": {
        "total": 1,
        "ts": 1774572899764,
        "count": 1,
        "id": "1772230537869-86781-LNymX-item",
        "totalSpent": 100
      }
    }
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "ts": 1773161482263,
        "id": "1772590648474-86781-LNymX-level",
        "count": 1
      }
    },
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "icon": "",
    "fName": "Ivy",
    "team": false,
    "lName": "Sinclair",
    "newStuff": [],
    "legalApproved": 1773161491976,
    "currency": 200,
    "currencyTotal": 200,
    "path": "q5cqhyxw6mpw9rd3ni",
    "appId": "43jfbVFSXCVW0uMFZk209aXq",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "gradient": "linear-gradient(to top, #f99e72, #3b2bd3)",
    "status": "active",
    "ts_lastLogin": 1773161480888,
    "alias": "Inventive Mantis",
    "info": "HR - Blackwood",
    "displayName": "Ivy S"
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "icon": "",
    "points": 0,
    "ts_joined": 1772202099979,
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "path": "s_04hnqzcm2yjumnb0",
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Marcus",
    "team": false,
    "lName": "Thorne",
    "gradient": "linear-gradient(to top, #065868, #3c6b24)",
    "status": "active",
    "ts": 1772202099979,
    "appId": "7bPBjTWkxR94cOxfRFHw3UHf",
    "enroll_method": "upload",
    "info": "HR - Thorne",
    "alias": "Faithful Deer",
    "displayName": "Marcus T"
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "gradient": "linear-gradient(to left, #b8b43c, #9fb4c1)",
    "status": "active",
    "ts_lastLogin": 1774644411726,
    "enroll_method": "upload",
    "appId": "7ms5igiTjjh4cLmunxfSTJU9",
    "ts": 1772202099979,
    "displayName": "Victor H",
    "alias": "Questioning Hawk",
    "info": "HR - Blackwood",
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "ts_joined": 1772202099979,
    "points": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "count": 1,
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1774643897439
      }
    },
    "currency": 300,
    "currencyTotal": 300,
    "path": "x3tvmbhymif00362ni",
    "newStuff": [],
    "legalApproved": 1774643896068,
    "lName": "Hugo",
    "fName": "Victor",
    "team": false
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "icon": "",
    "items": {
      "1772230537866-86781-LNymX-item": {
        "id": "1772230537866-86781-LNymX-item",
        "ts": 1774615663454,
        "count": 1
      },
      "1772230537870-86781-LNymX-item": {
        "id": "1772230537870-86781-LNymX-item",
        "ts": 1774615663456,
        "count": 1
      }
    },
    "fName": "Silas",
    "team": false,
    "lName": "Vane",
    "newStuff": [
      {
        "type": "rewards",
        "display": "reward",
        "id": "1774615663449-A9Z54ybEdO08J7BH5Mpynx03-rewards",
        "icon": "/images/icons/treasure.png",
        "data": [
          {
            "quantity": 300,
            "id": "currency",
            "type": "currency"
          },
          {
            "quantity": 1,
            "type": "prizepack",
            "id": "1772590997526-86781-LNymX-prizepack"
          }
        ],
        "ts": 1774615663449
      },
      {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "type": "rewards",
        "display": "prizepack",
        "id": "1774615663453-A9Z54ybEdO08J7BH5Mpynx03-prizepack",
        "data": [
          {
            "type": "items",
            "id": "1772230537866-86781-LNymX-item",
            "quantity": 1
          },
          {
            "id": "1772230537866-86781-LNymX-item",
            "type": "items",
            "quantity": 1
          },
          {
            "quantity": 1,
            "type": "items",
            "id": "1772230537870-86781-LNymX-item"
          }
        ],
        "ts": 1774615663453
      }
    ],
    "currencyTotal": 300,
    "currency": 300,
    "path": "bmvh6aoda7y9uojcw_",
    "appId": "A9Z54ybEdO08J7BH5Mpynx03",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "gradient": "linear-gradient(to left, #70a495, #cd4f39)",
    "status": "active",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "ts": 1774615663452,
        "id": "1772590997526-86781-LNymX-prizepack",
        "count": 1
      }
    },
    "alias": "Cautious Curlew",
    "info": "HR - Thorne",
    "displayName": "Silas V"
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "alias": "Busy Jaguar",
    "info": "HR - Blackwood",
    "displayName": "Isabella R",
    "gradient": "linear-gradient(to top, #7d295a, #d61cff)",
    "status": "active",
    "appId": "EDJjcSJkQhCj8Su3009yDf3F",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "currency": 0,
    "currencyTotal": 0,
    "path": "0d4po53js6vt59f8zj",
    "fName": "Isabella",
    "team": false,
    "lName": "Romero",
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "icon": "",
    "fName": "Penelope",
    "team": false,
    "lName": "Weaver",
    "path": "p_ui6ws5754qspj2fk",
    "currencyTotal": 0,
    "currency": 0,
    "ts": 1772202099979,
    "appId": "G8cicVkGq7yorRPXCKd6ydnM",
    "enroll_method": "upload",
    "gradient": "linear-gradient(to left, #22e58e, #ff6fa6)",
    "status": "active",
    "info": "HR - Blackwood",
    "alias": "Popular Dolphin",
    "displayName": "Penelope W"
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "count": 1,
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1772981266523
      }
    },
    "icon": "",
    "lName": "Finch",
    "fName": "Jasper",
    "team": false,
    "currencyTotal": 200,
    "currency": 200,
    "path": "cudo2o__jhdh0_hm42",
    "legalApproved": 1772981270753,
    "newStuff": [],
    "enroll_method": "upload",
    "appId": "GuYrAf2A7ofKh6Kim4OGv2ur",
    "ts": 1772202099979,
    "gradient": "linear-gradient(to top, #12cf02, #ce2e13)",
    "status": "active",
    "ts_lastLogin": 1772980733338,
    "displayName": "Jasper F",
    "alias": "Patient Crane",
    "info": "HR - Thorne"
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_joined": 1772686800409,
    "points": 0,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772687197598-Gemini_Generated_Image_mko59pmko59pmko5.jpg?alt=media&token=abb6c0e9-b303-4651-930f-3ffd96b834b0",
    "fName": "The Gilded Senate",
    "team": true,
    "path": "7i9p9j_gwi7x0bwowq",
    "appId": "J9xWK94hGWoQ7Kw05OZo_team",
    "ts": 1772687199072,
    "status": "active",
    "displayName": "The Gilded Senate",
    "desc": "Named after the Senatus, the governing body of Rome. This title fits a team that excels at the rhetorical and analytical side of your literature curriculum the ones who love a good Socratic seminar.",
    "opt_activeMemberCount": 8,
    "name": "The Gilded Senate",
    "opt_members": [
      "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
      "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
      "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
      "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
      "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
      "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
      "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
      "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9"
    ]
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "alias": "Jealous Narwhal",
    "info": "HR - Blackwood",
    "displayName": "Theodore C",
    "gradient": "linear-gradient(to right, #f10868, #1ab0cb)",
    "status": "active",
    "ts_lastLogin": 1774615589881,
    "appId": "JSx4p6pOdtEAGMvzmX3AcbwT",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "legalApproved": 1774615592607,
    "newStuff": [],
    "currencyTotal": 200,
    "currency": 0,
    "path": "yq78c6apfeqf97sw_-",
    "team": false,
    "fName": "Theodore",
    "lName": "Crane",
    "icon": "",
    "items": {
      "1772230537871-86781-LNymX-item": {
        "count": 1,
        "total": 2,
        "ts": 1774623170292,
        "totalSpent": 200,
        "id": "1772230537871-86781-LNymX-item"
      }
    },
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "count": 1,
        "ts": 1774615595942,
        "id": "1772590648474-86781-LNymX-level"
      }
    },
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "displayName": "Elara F",
    "status": "active",
    "path": "2uiwtc_w9wo88dhqj9",
    "currencyTotal": 1450,
    "team": false,
    "fName": "Elara",
    "lName": "Frost",
    "icon": "",
    "items": {
      "1772230537887-86781-LNymX-item": {
        "count": 1,
        "ts": 1774497798492,
        "id": "1772230537887-86781-LNymX-item",
        "total": 1
      },
      "1772230537890-86781-LNymX-item": {
        "ts": 1774497583575,
        "id": "1772230537890-86781-LNymX-item",
        "count": 1
      },
      "1772230537891-86781-LNymX-item": {
        "id": "1772230537891-86781-LNymX-item",
        "ts": 1774497798488,
        "count": 1
      },
      "1772230537889-86781-LNymX-item": {
        "count": 1,
        "ts": 1774497798489,
        "id": "1772230537889-86781-LNymX-item"
      },
      "1772230537888-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537888-86781-LNymX-item",
        "ts": 1774497583577
      },
      "1772230537866-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537866-86781-LNymX-item",
        "ts": 1774497583576
      },
      "1772230537870-86781-LNymX-item": {
        "id": "1772230537870-86781-LNymX-item",
        "ts": 1774497967891,
        "count": 1
      },
      "1772230537868-86781-LNymX-item": {
        "id": "1772230537868-86781-LNymX-item",
        "ts": 1774497798487,
        "count": 1
      }
    },
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "challenges": {
      "1772572118651-86781-LNymX-challenge": {
        "tries": 2,
        "id": "1772572118651-86781-LNymX-challenge",
        "approved": true,
        "ts": 1774501243641,
        "count": 1
      },
      "1772569886040-86781-LNymX-challenge": {
        "count": 0,
        "ts": 1774818340234,
        "id": "1772569886040-86781-LNymX-challenge",
        "tries": 1
      },
      "1772569770551-86781-LNymX-challenge": {
        "count": 1,
        "approved": true,
        "ts": 1774498029778,
        "tries": 2,
        "id": "1772569770551-86781-LNymX-challenge"
      }
    },
    "info": "HR - Blackwood",
    "alias": "Confident Giraffe",
    "ts_lastLogin": 1774813401768,
    "gradient": "linear-gradient(to right, #99064e, #6e8490)",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "ts": 1774501446840,
        "id": "1772590997526-86781-LNymX-prizepack",
        "count": 4
      }
    },
    "secretCodes": {
      "1772595348387-86781-LNymX-secretCode": {
        "count": 1,
        "ts": 1774497798483,
        "id": "1772595348387-86781-LNymX-secretCode"
      },
      "1772595348384-86781-LNymX-secretCode": {
        "id": "1772595348384-86781-LNymX-secretCode",
        "ts": 1774497967887,
        "count": 1
      },
      "1772595348383-86781-LNymX-secretCode": {
        "id": "1772595348383-86781-LNymX-secretCode",
        "ts": 1774497583571,
        "count": 1
      }
    },
    "ts": 1772202099979,
    "appId": "OKBBAo2RM44OS9DjaPrHxwrU",
    "enroll_method": "upload",
    "newStuff": [],
    "legalApproved": 1774497543178,
    "currency": 1450,
    "collections": {
      "1772233183963-86781-LNymX-collection": {
        "id": "1772233183963-86781-LNymX-collection",
        "ts": 1774497798492,
        "count": 1
      }
    },
    "levels": {
      "1772590711756-86781-LNymX-level": {
        "count": 1,
        "ts": 1774501446837,
        "id": "1772590711756-86781-LNymX-level"
      },
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1774497543501,
        "count": 1
      }
    },
    "gameId": "1772165586781-LNymXRI-game",
    "points": 600,
    "ts_joined": 1772202099979
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "path": "0cq39ufq8-sigmeb3y",
    "currencyTotal": 300,
    "currency": 300,
    "newStuff": [
      {
        "data": [
          {
            "quantity": 300,
            "id": "currency",
            "type": "currency"
          },
          {
            "type": "prizepack",
            "id": "1772590997526-86781-LNymX-prizepack",
            "quantity": 1
          }
        ],
        "ts": 1774615663446,
        "display": "reward",
        "type": "rewards",
        "id": "1774615663446-YF29Cw25nRFWUe6t37OtFiwm-rewards",
        "icon": "/images/icons/treasure.png"
      },
      {
        "data": [
          {
            "quantity": 1,
            "id": "1772230537890-86781-LNymX-item",
            "type": "items"
          },
          {
            "quantity": 1,
            "id": "1772230537889-86781-LNymX-item",
            "type": "items"
          },
          {
            "type": "items",
            "id": "1772230537875-86781-LNymX-item",
            "quantity": 1
          }
        ],
        "ts": 1774615663450,
        "id": "1774615663450-YF29Cw25nRFWUe6t37OtFiwm-prizepack",
        "type": "rewards",
        "display": "prizepack",
        "hideUntilOpened": ["1774615663446-YF29Cw25nRFWUe6t37OtFiwm-rewards"],
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
      }
    ],
    "lName": "Maxwell",
    "fName": "Leo",
    "team": false,
    "items": {
      "1772230537875-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537875-86781-LNymX-item",
        "ts": 1774615663453
      },
      "1772230537889-86781-LNymX-item": {
        "count": 1,
        "ts": 1774615663452,
        "id": "1772230537889-86781-LNymX-item"
      },
      "1772230537890-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537890-86781-LNymX-item",
        "ts": 1774615663451
      }
    },
    "icon": "",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_joined": 1772202099979,
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "displayName": "Leo M",
    "info": "HR - Thorne",
    "alias": "Neat Mouse",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "count": 1,
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774615663449
      }
    },
    "gradient": "linear-gradient(to left, #d8be5d, #36ef15)",
    "status": "active",
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "YF29Cw25nRFWUe6t37OtFiwm"
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "ZCYz3Xwi3rCgnv6BMyZPV88E",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "count": 1,
        "ts": 1774663210141,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "secretCodes": {
      "1772595348386-86781-LNymX-secretCode": {
        "count": 1,
        "ts": 1774663210139,
        "id": "1772595348386-86781-LNymX-secretCode"
      }
    },
    "ts_lastLogin": 1774663155925,
    "gradient": "linear-gradient(to bottom, #04555b, #2c2c09)",
    "info": "HR - Thorne",
    "alias": "Reverent Newt",
    "points": 0,
    "ts_joined": 1772202099979,
    "gameId": "1772165586781-LNymXRI-game",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1774663161105,
        "count": 1
      }
    },
    "currency": 50,
    "newStuff": [],
    "legalApproved": 1774663159555,
    "status": "active",
    "displayName": "Beatrice K",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "items": {
      "1772230537866-86781-LNymX-item": {
        "count": 1,
        "id": "1772230537866-86781-LNymX-item",
        "ts": 1774663210144
      },
      "1772230537868-86781-LNymX-item": {
        "count": 1,
        "ts": 1774663210143,
        "id": "1772230537868-86781-LNymX-item"
      },
      "1772230537875-86781-LNymX-item": {
        "ts": 1774663210145,
        "id": "1772230537875-86781-LNymX-item",
        "count": 1
      },
      "1772230537885-86781-LNymX-item": {
        "id": "1772230537885-86781-LNymX-item",
        "totalSpent": 200,
        "ts": 1774663185406,
        "total": 1,
        "count": 1
      }
    },
    "icon": "",
    "lName": "Knight",
    "fName": "Beatrice",
    "team": false,
    "path": "arkjkd_em_5kc_7dsc",
    "currencyTotal": 250
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "ts_lastLogin": 1774535366694,
    "gradient": "linear-gradient(to bottom, #8dd86c, #79ba99)",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "count": 2,
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774615663450
      }
    },
    "secretCodes": {
      "1772595348385-86781-LNymX-secretCode": {
        "count": 1,
        "id": "1772595348385-86781-LNymX-secretCode",
        "ts": 1774535601047
      }
    },
    "ts": 1772202099979,
    "appId": "ZvZ0CMN6ywykvdvTHuOPvRKz",
    "enroll_method": "upload",
    "challenges": {
      "1772569770551-86781-LNymX-challenge": {
        "count": 0,
        "declined": 1,
        "ts": 1774536340963,
        "tries": 1,
        "id": "1772569770551-86781-LNymX-challenge"
      },
      "1772569886040-86781-LNymX-challenge": {
        "tries": 2,
        "id": "1772569886040-86781-LNymX-challenge",
        "count": 1,
        "approved": true,
        "ts": 1774535538361
      }
    },
    "info": "HR - Thorne",
    "alias": "Mischievous Mouse",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1774535368931,
        "count": 1
      }
    },
    "ts_joined": 1772202099979,
    "points": 150,
    "gameId": "1772165586781-LNymXRI-game",
    "legalApproved": 1774535371260,
    "newStuff": [
      {
        "type": "approvedChallenge",
        "display": "achievement",
        "id": "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
        "elementId": "1772569886040-86781-LNymX-challenge",
        "data": [
          {
            "quantity": 150,
            "type": "xp",
            "id": "xp"
          },
          {
            "id": "currency",
            "type": "currency",
            "quantity": 150
          }
        ],
        "ts": 1774572338000
      },
      {
        "type": "declinedChallenge",
        "id": "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge",
        "display": "playerActivity",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
        "ts": 1774572403947,
        "elementId": "1772569770551-86781-LNymX-challenge"
      },
      {
        "icon": "/images/icons/treasure.png",
        "type": "rewards",
        "id": "1774615663447-ZvZ0CMN6ywykvdvTHuOPvRKz-rewards",
        "display": "reward",
        "data": [
          {
            "id": "currency",
            "type": "currency",
            "quantity": 300
          },
          {
            "type": "prizepack",
            "id": "1772590997526-86781-LNymX-prizepack",
            "quantity": 1
          }
        ],
        "ts": 1774615663447
      },
      {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "type": "rewards",
        "display": "prizepack",
        "id": "1774615663451-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack",
        "data": [
          {
            "quantity": 1,
            "type": "items",
            "id": "1772230537875-86781-LNymX-item"
          },
          {
            "quantity": 1,
            "type": "items",
            "id": "1772230537868-86781-LNymX-item"
          },
          {
            "id": "1772230537868-86781-LNymX-item",
            "type": "items",
            "quantity": 1
          }
        ],
        "ts": 1774615663451
      }
    ],
    "currency": 500,
    "status": "active",
    "displayName": "Sofia R",
    "icon": "",
    "items": {
      "1772230537875-86781-LNymX-item": {
        "ts": 1774615663452,
        "id": "1772230537875-86781-LNymX-item",
        "count": 1
      },
      "1772230537890-86781-LNymX-item": {
        "count": 1,
        "ts": 1774535601051,
        "id": "1772230537890-86781-LNymX-item"
      },
      "1772230537868-86781-LNymX-item": {
        "id": "1772230537868-86781-LNymX-item",
        "ts": 1774615663453,
        "count": 1
      },
      "1772230537866-86781-LNymX-item": {
        "count": 1,
        "ts": 1774535601052,
        "id": "1772230537866-86781-LNymX-item"
      },
      "1772230537888-86781-LNymX-item": {
        "ts": 1774535601053,
        "id": "1772230537888-86781-LNymX-item",
        "count": 1
      },
      "1772230537881-86781-LNymX-item": {
        "id": "1772230537881-86781-LNymX-item",
        "totalSpent": 200,
        "total": 1,
        "ts": 1774535391305,
        "count": 1
      }
    },
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "path": "bid38pzjhsn52cckdr",
    "currencyTotal": 700,
    "team": false,
    "fName": "Sofia",
    "lName": "Ricci"
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "fName": "Xavier",
    "team": false,
    "lName": "Cross",
    "newStuff": [
      {
        "type": "rewards",
        "id": "1774495493476-axOQve3xXxzhqJ7OPczuoZFm-rewards",
        "display": "reward",
        "icon": "/images/icons/treasure.png",
        "data": [
          {
            "id": "xp",
            "type": "xp",
            "quantity": 20
          },
          {
            "quantity": 100,
            "type": "currency",
            "id": "currency"
          }
        ],
        "ts": 1774495493476
      },
      {
        "data": [
          {
            "type": "currency",
            "id": "currency",
            "quantity": 300
          },
          {
            "type": "prizepack",
            "id": "1772590997526-86781-LNymX-prizepack",
            "quantity": 1
          }
        ],
        "ts": 1774615663445,
        "icon": "/images/icons/treasure.png",
        "type": "rewards",
        "display": "reward",
        "id": "1774615663445-axOQve3xXxzhqJ7OPczuoZFm-rewards"
      },
      {
        "data": [
          {
            "type": "items",
            "id": "1772230537866-86781-LNymX-item",
            "quantity": 1
          },
          {
            "id": "1772230537866-86781-LNymX-item",
            "type": "items",
            "quantity": 1
          },
          {
            "quantity": 1,
            "type": "items",
            "id": "1772230537868-86781-LNymX-item"
          }
        ],
        "ts": 1774615663449,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "id": "1774615663449-axOQve3xXxzhqJ7OPczuoZFm-prizepack",
        "display": "prizepack",
        "type": "rewards"
      }
    ],
    "legalApproved": 1772894691873,
    "path": "m9pwe3ddnqf0wto0rn",
    "currency": 400,
    "currencyTotal": 400,
    "gameId": "1772165586781-LNymXRI-game",
    "points": 20,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "icon": "",
    "items": {
      "1772230537868-86781-LNymX-item": {
        "count": 1,
        "ts": 1774615663452,
        "id": "1772230537868-86781-LNymX-item"
      },
      "1772230537866-86781-LNymX-item": {
        "count": 1,
        "ts": 1774615663450,
        "id": "1772230537866-86781-LNymX-item"
      }
    },
    "info": "HR - Blackwood",
    "alias": "Reflective Mink",
    "displayName": "Xavier C",
    "ts": 1772202099979,
    "appId": "axOQve3xXxzhqJ7OPczuoZFm",
    "enroll_method": "upload",
    "ts_lastLogin": 1772894684244,
    "gradient": "linear-gradient(to right, #03edc1, #684c5e)",
    "status": "active",
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "count": 1,
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774615663448
      }
    }
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "path": "0w6gfikhjtsg8k5a6e",
    "currency": 0,
    "currencyTotal": 0,
    "lName": "Whitlock",
    "team": false,
    "fName": "Clara",
    "icon": "",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_joined": 1772202099979,
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "displayName": "Clara W",
    "info": "HR - Thorne",
    "alias": "Honest Moose",
    "gradient": "linear-gradient(to right, #d9e188, #d8a77f)",
    "status": "active",
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "cVwFFJ72qLb6vLiLeFMwnEcA"
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "icon": "",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "path": "f25m7jpgqzguoa8gad",
    "currency": 0,
    "currencyTotal": 0,
    "lName": "Holt",
    "team": false,
    "fName": "Gideon",
    "gradient": "linear-gradient(to top, #6bb507, #6d468e)",
    "status": "active",
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "cx9brBsPCSThk2ZdNLRSnukr",
    "displayName": "Gideon H",
    "info": "HR - Blackwood",
    "alias": "Responsible Grouse"
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "fName": "Felix",
    "team": false,
    "lName": "Aris",
    "newStuff": [
      {
        "data": [
          {
            "id": "xp",
            "type": "xp",
            "quantity": 20
          },
          {
            "quantity": 100,
            "id": "currency",
            "type": "currency"
          }
        ],
        "ts": 1774495493475,
        "type": "rewards",
        "id": "1774495493475-dorHnQBtZQdnQ2brude9SEdJ-rewards",
        "display": "reward",
        "icon": "/images/icons/treasure.png"
      }
    ],
    "path": "nji5j50yzk6a-w66tw",
    "currency": 100,
    "currencyTotal": 100,
    "ts_joined": 1772202099979,
    "points": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "icon": "",
    "info": "HR - Thorne",
    "alias": "Joyful Dragonfly",
    "displayName": "Felix A",
    "ts": 1772202099979,
    "appId": "dorHnQBtZQdnQ2brude9SEdJ",
    "enroll_method": "upload",
    "gradient": "linear-gradient(to left, #7473dd, #5c264f)",
    "status": "active"
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "currency": 0,
    "currencyTotal": 0,
    "path": "79yk7k4me-amx5v7oq",
    "lName": "Vance",
    "team": false,
    "fName": "Elena",
    "gradient": "linear-gradient(to top, #1141b2, #aa3286)",
    "status": "active",
    "enroll_method": "upload",
    "appId": "eNuL3JKENON6662mFntnZyv5",
    "ts": 1772202099979,
    "displayName": "Elena V",
    "alias": "Popular Hornet",
    "info": "HR - Thorne"
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772686313525,
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "path": "kihibc_szszkza4zvo",
    "fName": "The Iron Legion",
    "team": true,
    "status": "active",
    "ts": 1773006986422,
    "appId": "eRzU3eBELXk4t0Zaf5Bb_team",
    "opt_activeMemberCount": 9,
    "opt_members": [
      "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
      "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
      "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
      "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
      "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
      "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
      "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
      "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm"
    ],
    "name": "The Iron Legion",
    "displayName": "The Iron Legion",
    "desc": "Inspired by the Legio, the backbone of the Roman army. This name is perfect for a group that is highly organized and tackles challenges with a \"never leave a man behind\" mentality."
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "fName": "Lydia",
    "team": false,
    "lName": "Bennet",
    "currencyTotal": 0,
    "currency": 0,
    "path": "t4zaa6v4qxffjjxqjh",
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "icon": "",
    "alias": "Responsible Eel",
    "info": "HR - Blackwood",
    "displayName": "Lydia B",
    "appId": "emdu4nKOrWqe9ATaTLi5Axc0",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "gradient": "linear-gradient(to right, #05dbbf, #1d69db)",
    "status": "active"
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "ts_joined": 1772687769760,
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "path": "w0c77_x8tyf27nm9ee",
    "team": true,
    "fName": "The Oracle Guard",
    "status": "active",
    "ts": 1773002413898,
    "appId": "h8k7HFwBmE4vrFzfMS9G_team",
    "opt_activeMemberCount": 9,
    "opt_members": [
      "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
      "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
      "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
      "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
      "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
      "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
      "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
      "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr"
    ],
    "name": "The Oracle Guard",
    "displayName": "The Oracle Guard",
    "desc": "Drawing from the Sibylline Oracles and the protectors of sacred knowledge. This name is ideal for the group that digs deep into symbolism and always seems to find the \"hidden meaning\" in the texts you read."
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "gradient": "linear-gradient(to left, #f0c657, #d45525)",
    "status": "active",
    "ts": 1772202099979,
    "appId": "iwdiTziEseTdazwH7CNQ4cQ3",
    "enroll_method": "upload",
    "info": "HR - Thorne",
    "alias": "Pleasing Flamingo",
    "displayName": "Maya H",
    "icon": "",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "path": "pqmssxtk4ahxkbky96",
    "currency": 0,
    "currencyTotal": 0,
    "team": false,
    "fName": "Maya",
    "lName": "Huxley"
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "currency": 0,
    "currencyTotal": 0,
    "path": "s_zzkdwuk_iqor5b7d",
    "lName": "Thorne",
    "team": false,
    "fName": "Hazel",
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "ts_joined": 1772202099979,
    "displayName": "Hazel T",
    "alias": "Confident Mosquito",
    "info": "HR - Blackwood",
    "gradient": "linear-gradient(to bottom, #c7c032, #93cd9c)",
    "status": "active",
    "enroll_method": "upload",
    "appId": "oVnAPXEE9kyQjHUCnMyZ22Bx",
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "currency": 0,
    "currencyTotal": 0,
    "path": "0hwqwaja88v_yhj68f",
    "lName": "Miller",
    "team": false,
    "fName": "Quentin",
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_joined": 1772202099979,
    "points": 0,
    "displayName": "Quentin M",
    "alias": "Questioning Moose",
    "info": "HR - Blackwood",
    "gradient": "linear-gradient(to top, #1d7b17, #a5d001)",
    "status": "active",
    "ts_lastLogin": 1773108928574,
    "enroll_method": "upload",
    "appId": "opW78wiKB0bZREJcvuaYOKYn",
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "displayName": "Adrian C",
    "info": "HR - Thorne",
    "alias": "Honest Badger",
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "vjAwf0SQG9VKrhzeyiN2bSS3",
    "gradient": "linear-gradient(to right, #c6864c, #d3e4c0)",
    "status": "active",
    "lName": "Chen",
    "fName": "Adrian",
    "team": false,
    "path": "ewciz9aohx7y0fd8dx",
    "currency": 0,
    "currencyTotal": 0,
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "icon": ""
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "displayName": "Nadia S",
    "info": "HR - Thorne",
    "alias": "Bold Mantis",
    "enroll_method": "upload",
    "ts": 1772202099979,
    "appId": "w77EzNVefc5J22ZSzabDvbQr",
    "gradient": "linear-gradient(to bottom, #312bcc, #21f35d)",
    "status": "active",
    "lName": "Solis",
    "team": false,
    "fName": "Nadia",
    "path": "7auhs3ex3h2hcqgnu-",
    "currencyTotal": 100,
    "currency": 100,
    "newStuff": [
      {
        "data": [
          {
            "quantity": 20,
            "type": "xp",
            "id": "xp"
          },
          {
            "quantity": 100,
            "id": "currency",
            "type": "currency"
          }
        ],
        "ts": 1774495493478,
        "id": "1774495493478-w77EzNVefc5J22ZSzabDvbQr-rewards",
        "type": "rewards",
        "display": "reward",
        "icon": "/images/icons/treasure.png"
      }
    ],
    "ts_joined": 1772202099979,
    "points": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "icon": ""
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "alias": "Strong Kookabura",
    "info": "HR - Blackwood",
    "displayName": "Rowan G",
    "gradient": "linear-gradient(to right, #e10a7e, #83caed)",
    "status": "active",
    "appId": "zqXbjKmmoiZaZEsNV9tgxQrG",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "currency": 0,
    "currencyTotal": 0,
    "path": "xiss055dto09dgynf7",
    "fName": "Rowan",
    "team": false,
    "lName": "Graves",
    "icon": "",
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game"
  }
}